<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex shrink style="text-align: right"
          ><v-btn
            @click="printPage()"
            dark
            style="width: 80px; background-color: black"
            ><v-icon>local_printshop</v-icon></v-btn
          ></v-flex
        >
        <!-- Nevigater -->
        <v-layout mb-12 v-if="$route.query.name === 'verify-rf'">
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>ตรวจสอบแบบฟอร์ม RF</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานเหตุการณ์การไม่พึ่งประสงค์ (นอกเหนือจากยา)</span>
          </v-flex>
        </v-layout>
        <v-layout v-else mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานเหตุการณ์การไม่พึ่งประสงค์ (นอกเหนือจากยา)</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout>
              <v-flex>
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: left; font-size: 28px; color: white"
                  >
                    <div style="font-weight: bold">
                      แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE)
                    </div>
                    <div style="font-size: 18px">Adverse Event Report</div>
                  </v-flex>
                  <v-flex
                    ml-8
                    pt-8
                    pr-8
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 13px;
                      color: white;
                    "
                  >
                    <span>RF 04_2_2563</span>
                  </v-flex>
                </v-layout>

                <!-- blog 1 -->
                <v-card
                  class="py-12"
                  style="padding-right: 80px; padding-left: 80px"
                >
                  <v-layout>
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>1. รหัสโครงการ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textfield-form
                            :model="form.researchCode"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>

                      <!-- row 2 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>2. ชื่อโครงการวิจัย</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textarea-form
                            :model="form.researchName"
                            readonly
                          ></textarea-form>
                        </v-flex>
                      </v-layout>

                      <!-- row 3 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>3. ชื่อผู้วิจัยหลัก</span>
                        </v-flex>
                      </v-layout>
                      <v-layout px-4>
                        <v-flex style="color: #3e7662">
                          <textfield-form
                            label="ชื่อ"
                            :model="form.firstName"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex ml-3 style="color: #3e7662">
                          <textfield-form
                            label="นามสกุล"
                            :model="form.lastName"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>

                      <!-- row 4 -->
                      <v-layout pb-3>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>4. สังกัด / เบอร์โทรศัพท์ติดต่อ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout pb-3>
                        <v-flex>
                          <textfield-form
                            :model="form.affiliationAndPhoneNumber"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>

                      <!-- row 5 -->
                      <v-layout pb-3 justify-space-between>
                        <v-flex
                          mr-6
                          shrink
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>5. อาสาสมัคร</span>
                        </v-flex>
                        <v-flex
                          shrink
                          style="text-align: left; font-weight: bold"
                          mt-1
                        >
                          <v-checkbox
                            readonly
                            color="#3E7662"
                            v-model="form.volunteer_checkbox"
                            hide-details
                          />
                        </v-flex>
                        <v-flex
                          mr-6
                          shrink
                          d-flex
                          align-center
                          style="
                            text-align: left;
                            font-weight: bold;
                            color: #cc3d45;
                          "
                        >
                          <span>ในสถาบัน *ระบุหน่วย</span>
                        </v-flex>
                        <v-flex d-flex align-center>
                          <textfield-form
                            :disabled="!form.volunteer_checkbox"
                            hide-detail
                            :model="form.volunteerDepartment"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>

                      <!-- row 6 -->
                      <v-layout pt-6 justify-space-between>
                        <v-flex
                          mr-10
                          shrink
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>6. ชื่อย่อ/รหัสอาสาสมัคร Patient Initial</span>
                        </v-flex>
                        <v-flex d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="form.volunteerCode"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>

                      <!-- row 7 -->
                      <v-layout pt-10>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>7. วันเกิด</span>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <TextfieldForm
                            hide-detail
                            style="color: #3e7662"
                            :model="birthDate"
                            readonly
                          />
                        </v-flex>
                        <v-flex justify-end xs2 d-flex align-center>
                          <span style="text-align: left; font-weight: bold"
                            >8. อายุ</span
                          >
                        </v-flex>
                        <v-flex xs2 mx-4 d-flex align-center>
                          <textfield-form
                            hide-detail
                            :model="form.age"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <span style="text-align: left; font-weight: bold"
                            >ปี</span
                          >
                        </v-flex>
                      </v-layout>

                      <!-- row 8 -->
                      <v-layout mt-4>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>9. เพศ</span>
                        </v-flex>
                        <v-flex
                          pt-6
                          d-flex
                          align-center
                          style="text-align: left"
                        >
                          <v-radio-group readonly v-model="form.gender" row>
                            <v-radio
                              color="#3E7662"
                              style="padding-right: 40px"
                              label="ชาย"
                              value="0"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="หญิง"
                              value="1"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- row 9 -->
                      <v-layout mt-4>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>10.1 วันที่เกิดอาการ</span>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <TextfieldForm
                            hide-detail
                            style="color: #3e7662"
                            :model="date"
                            readonly
                          />
                        </v-flex>
                      </v-layout>

                      <v-layout mt-4>
                        <v-flex
                          xs2
                          mr-10
                          d-flex
                          align-center
                          style="text-align: left; font-weight: bold"
                        >
                          <span>10.2 วันที่ผู้วิจัยทราบ</span>
                        </v-flex>
                        <v-flex xs2 d-flex align-center>
                          <TextfieldForm
                            hide-detail
                            style="color: #3e7662"
                            :model="dateKnow"
                            readonly
                          />
                        </v-flex>
                      </v-layout>

                      <!-- row 9 -->
                      <v-layout mb-3 mt-10>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span
                            >11.รายละเอียดเหตุการณ์ไม่พึงประสงค์
                            (รวมทั้งการตรวจทางห้องปฏิบัติการ)</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textarea-form
                            readonly
                            hide-detail
                            :model="form.detail"
                            :rows="8"
                          />
                        </v-flex>
                      </v-layout>

                      <!-- row 10 -->
                      <v-layout mb-3 mt-10>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span>12. ชนิดของการรายงาน</span>
                        </v-flex>
                      </v-layout>
                      <v-layout ml-4>
                        <v-flex>
                          <v-flex>
                            <v-radio-group readonly v-model="form.type" row>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 100px"
                                label="ครั้งแรก Initial report"
                                value="0"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                label="เพื่อติดตาม Follow-up report"
                                value="1"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-flex>
                      </v-layout>

                      <!-- row 11 -->
                      <v-layout mb-3 mt-4>
                        <v-flex style="text-align: left; font-weight: bold">
                          <span
                            >13. ความสัมพันธ์กับการวิจัย (Relation to the
                            study)</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout ml-4>
                        <v-flex>
                          <v-radio-group readonly v-model="form.relation">
                            <v-radio
                              color="#3E7662"
                              label="1. ไม่เกี่ยวข้อง (Not related)"
                              value="1"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="2. อาจเกี่ยวข้อง (Possibly related)"
                              value="2"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="3. น่าจะเกี่ยวข้อง (Probably related)"
                              value="3"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="4. เกี่ยวข้องแน่นอน (Definitely related)"
                              value="4"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="5. ไม่รู้ (Unknown)"
                              value="5"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <v-layout pt-10>
                        <v-flex
                          xs11
                          style="
                            text-align: left;
                            font-size: 14px;
                            color: #cc3d45;
                          "
                        >
                          <span>
                            *ถ้าเป็นเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง (ก 1-5)
                            ผู้วิจัยควรส่งรายงานแก่คณะอนุกรรมการพิจารณาโครงการวิจัย
                            พบ. ภายใน 7 วัน หลังทราบเหตุการณ์
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <v-layout
                  mt-12
                  py-12
                  style="
                    background-color: white;
                    padding-right: 80px;
                    padding-left: 80px;
                  "
                >
                  <v-flex>
                    <!-- row 1 -->
                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ก. ตรวจสอบความร้ายแรง (Seriousness)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.severity">
                          <v-radio
                            color="#3E7662"
                            label="1. ตาย (Death)"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. รุนแรงและอาจทำให้เสียชีวิต (Life threatening)"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="3. ต้องรักษาในโรงพยาบาล (Hospitalization / prolonged hospitalization)"
                            value="3"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="4. พิการหรือทุพลภาพ (Persistent or significant disability / incapacity)"
                            value="4"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="5. ทารกพิการแต่กำเนิด (Congenital anomaly / birth defect)"
                            value="5"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="6. ไม่ร้ายแรง"
                            value="6"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- blog 2 -->
                <v-layout
                  mt-12
                  py-12
                  style="
                    background-color: white;
                    padding-right: 80px;
                    padding-left: 80px;
                  "
                >
                  <v-flex>
                    <!-- row 4 -->
                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ก. การดำเนินเหตุการณ์ (Progression)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group readonly v-model="form.progression">
                          <v-radio
                            color="#3E7662"
                            label="1. แก้ไขแล้ว (Resolved)"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. ยังคงมีปัญหา (Ongoing)"
                            value="2"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="3. อื่นๆ (Others)"
                            value="3"
                          ></v-radio>
                          <textfield-form
                            v-if="form.progression === '3'"
                            label="ระบุ"
                            :model="form.otherProgression"
                            @update-data="
                              updateData('otherProgression', $event)
                            "
                          ></textfield-form>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <!-- row 5 -->
                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>ข. การเปลี่ยนแปลงโครงร่างการวิจัย</span>
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group
                          readonly
                          v-model="form.hasChangeResearch"
                        >
                          <v-radio
                            color="#3E7662"
                            label="1. ไม่เปลี่ยน"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 12_2563 ให้คณะอนุกรรมการฯ)"
                            value="2"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <!-- row 6 -->
                    <v-layout mt-8 mb-3>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >ค. การเปลี่ยนแปลงเอกสารชี้แจงข้อมูลอาสาสมัคร</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout ml-4>
                      <v-flex>
                        <v-radio-group
                          readonly
                          v-model="form.hasChangeDocument"
                        >
                          <v-radio
                            color="#3E7662"
                            label="1. ไม่เปลี่ยน"
                            value="1"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 12_2563 ให้คณะอนุกรรมการฯ)"
                            value="2"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout pt-10>
                      <v-flex
                        xs11
                        style="
                          text-align: left;
                          font-size: 14px;
                          color: #cc3d45;
                        "
                      >
                        <span>
                          *ถ้าเป็นเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง (ก 1-5)
                          ผู้วิจัยควรส่งรายงานแก่คณะอนุกรรมการพิจารณาโครงการวิจัย
                          พบ. ภายใน 7 วัน หลังทราบเหตุการณ์
                        </span>
                      </v-flex>
                    </v-layout>

                    <v-layout class="my-12">
                      <v-flex>
                        <v-layout class="mb-8">
                          <v-flex>
                            <v-layout>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >หนังสือของหน่วยงาน :
                                </span>
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  v-if="agencyBook"
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open"
                                >
                                  {{ agencyBook }}
                                </span>
                                <span
                                  v-else
                                  class="text-start"
                                  style="font-size: 12px; color: #cc3d45"
                                >
                                  -
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >เลขหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  readonly
                                  hide-detail
                                  :model="form.bookNumber"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mx-4 font-weight-bold"
                                shrink
                                >วันที่หนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  readonly
                                  :model="form.bookDate"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6 mt-5>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >หน่วยงานที่ออกหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  :model="form.instituteBook"
                                  @update-data="
                                    updateData('instituteBook', $event)
                                  "
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <!-- row 12 -->
                        <v-layout mb-3 style="margin-top: 8rem">
                          <v-flex style="text-align: left; font-weight: bold">
                            <span>ลงนามผู้วิจัย</span>
                          </v-flex>
                        </v-layout>
                        <v-layout ml-4>
                          <v-flex>
                            <TextfieldForm
                              style="color: #3e7662"
                              label="ชื่อ"
                              :model="form.signatureFirstName"
                              readonly
                            />
                          </v-flex>
                          <v-flex ml-12>
                            <TextfieldForm
                              style="color: #3e7662"
                              label="นามสกุล"
                              :model="form.signatureLastName"
                              readonly
                            />
                          </v-flex>
                        </v-layout>

                        <!-- row 13 -->
                        <v-layout mt-4 mb-12>
                          <v-flex
                            shrink
                            mr-4
                            d-flex
                            align-center
                            style="text-align: left; font-weight: bold"
                          >
                            <span>วันที่รายงาน</span>
                          </v-flex>
                          <v-flex xs2 d-flex align-center>
                            <TextfieldForm
                              hide-detail
                              style="color: #3e7662"
                              :model="reportDate"
                              readonly
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <div v-for="(input, k) in form.fileOther" :key="'d' + k" class="my-5">
                      <v-layout>
                        <v-flex>
                          <v-layout>
                            <v-flex
                              shrink
                              mr-4
                              pt-2
                              style="text-align: right;font-weight: bold;"
                            >
                              <span>ชื่อไฟล์</span>
                            </v-flex>
                            <v-flex xs2>
                              <textfield-form
                                hide-detail
                                :model="input.title"
                              ></textfield-form>
                            </v-flex>
                            <v-flex v-if="input.filePath"
                              ><a
                                :href="input.filePath"
                                target="_blank"
                                style="color: #3e7662;text-align: center"
                                class="link-hover"
                              >
                                <p>ไฟล์ที่อัพโหลด: {{ input.file }}</p>
                              </a>
                            </v-flex>
                            <!-- <v-flex shrink pt-2 px-4 style="text-align: left;">
                              <span style="font-weight: bold;font-size: 16px;"
                                >ไฟล์</span
                              >
                            </v-flex> -->
                            <!-- <v-flex>
                              <v-file-input
                                accept=".pdf"
                                prepend-icon=""
                                :id="'fileProtocolModify' + k"
                                :model="input.file"
                                outlined
                                dense
                                background-color="#FBF6F3"
                                color="#3E7662"
                                item-color="#3E7662"
                                @change="
                                  updateDynamicFileData('fileOther','file',k,$event)"
                              ></v-file-input>
                            </v-flex> -->
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex ml-4>
                          <v-btn
                            dark
                            style="background-color: #CC3D45; width: 80px"
                            @click="removeDynamicFile('fileOther', k)"
                            :disabled="form.fileOther.length < 1"
                          >
                            <v-icon>remove</v-icon>
                            <span class="font-weight-bold">ลบ</span>
                          </v-btn>
                        </v-flex> -->
                      </v-layout>
                      <v-layout> </v-layout>
                    </div>
                    <v-layout style="margin-top: 30px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>Note</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex style="padding-left: 32px; padding-right: 32px">
                        <textarea-form
                          @update-data="updateData('noteDetail', $event)"
                          :model="form.noteDetail"
                          :rows="5"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: -35px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>การตรวจสอบ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-left: 32px; margin-top: -15px">
                      <span style="font-weight: bold; padding-top: 19px"
                        >วันที่ผู้วิจัยรายงาน</span
                      >
                      <v-col cols="2" class="text-end text-field-center">
                        <DateInputForm
                          :model="researcherReportDate"
                          @update-data="
                            updateData('researcherReportDate', $event)
                          "
                          style="font-weight: bold"
                        ></DateInputForm>
                      </v-col>
                    </v-layout>
                    <v-layout
                      pt-12
                      justify-space-between
                      style="
                        font-weight: bold;
                        margin-left: -30px;
                        margin-right: -30px;
                      "
                    >
                      <v-flex d-flex justify-start>
                        <span
                          >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                        >
                      </v-flex>
                      <v-flex d-flex justify-end>
                        <span>หน้า 1 จาก 1 หน้า</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: left">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="$router.go(-1)"
                          >ย้อนกลับ</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex mb-12 style="text-align: right">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          v-if="status == 'รอดำเนินการ'"
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="saveEdit()"
                          ><v-icon>add</v-icon>บันทึกเพื่อแก้ไข</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- <pre class="text-center">{{ form }}</pre> -->
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../../components/input/TextfieldForm";
import TextareaForm from "../../../components/input/TextareaForm";
import DateInputForm from "../../../components/input/DateInputForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    TextareaForm,
    DateInputForm,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      fileOther: [],
      noteDetail: "",
      researcherReportDate: "",
      researchCode: "",
      researchName: "",
      firstName: "",
      lastName: "",
      affiliationAndPhoneNumber: "",
      volunteer_checkbox: false,
      volunteerDepartment: "",
      volunteerCode: "",
      birthDate: "",
      age: "",
      gender: "",
      date: "",
      detail: "",
      type: "",
      relation: "",
      signatureFirstName: "",
      signatureLastName: "",
      reportDate: "",
      severity: "1",
      hasCure: "",
      hasRecurrentAfterStop: "",
      progression: "",
      otherProgression: "",
      hasChangeResearch: "",
      hasChangeDocument: "",
      agencyBook: "",
      bookNumber: "",
      bookDate: "",
      instituteBook: "",
    },
    status: "",
    researcherReportDate: "",
    agencyBook: "",
    agencyBookLink: "",
    birthDate: "",
    date: "",
    dateKnow: "",
    reportDate: "",
    researchAllHeaders: [
      { text: "Version", value: "version", align: "center" },
      { text: "หน้า / บรรทัด", value: "page", align: "center" },
      { text: "ข้อมูลเดิม / ข้อเสนอแนะ", value: "data", align: "center" },
    ],
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.getRF04_2();
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function(element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function(element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function(element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function(element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function(element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function(element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function(error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function() {
            await document
              .querySelectorAll("button")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    saveEdit() {
      Swal.fire({
        title: "คุณต้องการบันทึกเพื่อแก้ไขหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึกเพื่อแก้ไข",
      }).then((result) => {
        if (result.value) {
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;

          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveEditRF04_2", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกเพื่อแก้ไขสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/verify-rf");
              });
              console.log("res", res);
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    updateData(name, val) {
      if (name === "researcherReportDate") {
        this.researcherReportDate = this.changeDate(val.date);
        this.form.researcherReportDate = val.date;
      }
      if (name === "noteDetail") {
        this.form.noteDetail = val;
      }
    },
    open() {
      window.open(this.agencyBookLink);
    },
    changeDate(val) {
      if (val != null) {
        //change date start
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return null;
      }
    },
    getRF04_2() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF04_2", this.$route.query.rfID)
        .then((res) => {
          console.log("res", res);
          this.form.fileOther = res.fileOther ?? [];
          this.form.instituteBook = res.instituteBook;
          this.status = res.status;
          this.form.noteDetail = res.noteDetail;
          this.form.researcherReportDate = res.noteDetailDate;
          this.researcherReportDate = this.changeDate(res.noteDetailDate);
          this.form.researchCode = res.researchCode;
          this.form.researchName = res.researchName;
          this.form.firstName = res.firstName;
          this.form.lastName = res.lastName;
          this.form.affiliationAndPhoneNumber = res.affiliationAndPhoneNumber;
          this.form.volunteer_checkbox = res.volunteer_checkbox;
          this.form.volunteerDepartment = res.volunteerDepartment;
          this.form.volunteerCode = res.volunteerCode;
          this.form.birthDate = res.birthDate;
          this.birthDate = this.changeDate(res.birthDate);
          this.form.age = res.age;
          this.form.gender = res.gender;
          this.form.date = res.date;
          this.date = this.changeDate(res.date);
          this.form.dateKnow = res.dateKnow;
          this.dateKnow = this.changeDate(res.dateKnow);
          this.form.detail = res.detail;
          this.form.type = res.type.toString();
          this.form.relation = res.relation.toString();
          this.form.signatureFirstName = res.signatureFirstName;
          this.form.signatureLastName = res.signatureLastName;
          this.form.reportDate = res.reportDate;
          this.reportDate = this.changeDate(res.reportDate);
          this.form.severity = res.severity.toString();
          // this.form.hasCure = res.hasCure.toString();
          // this.form.hasRecurrentAfterStop = res.hasRecurrentAfterStop.toString();
          this.form.progression = res.progression.toString();
          this.form.otherProgression = res.otherProgression;
          console.log(res.hasChangeResearch);
          this.form.hasChangeResearch = res.hasChangeResearch.toString();
          this.form.hasChangeDocument = res.hasChangeDocument.toString();

          this.agencyBookLink = res.agencyBookPath;
          this.agencyBook = res.agencyBook;
          this.form.bookNumber = res.bookNumber;
          this.form.bookDate = !res.bookDate
            ? ""
            : this.changeDate(res.bookDate);

          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
</style>
